import { Dashboard } from '@/containers/dashboard';
import { useGo } from '@/lib/useGo';

export default function DashboardRoute() {
  const go = useGo();
  return <Dashboard go={go} />;
}
